import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  makeStyles,
  CardContent,
  Button,
  ButtonGroup,
  Typography,
  Breadcrumbs,
  Link,
  Grid,
  Divider,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import UserAndDate from "src/components/common/UserAndDate";
import { kmLabels } from "src/constant/Texts";
import parse from "html-react-parser";
import { NavLink as RouterLink } from "react-router-dom";
import { fillMissingTags } from "src/utils/utils";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    fontWeight: 501,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  maincell: {
    paddingLeft: theme.spacing(2),
  },
  breadcrumbs: {
    paddingBottom: 0,
    marginBottom: 0,
  },
}));

const elementStatus = {
  published: "Opublikowany",
  draft: "Wersja robocza",
};

const attendanceInfo = {
  participation: "Udział w posiedzienu potwierdzony ",
  no_participation: "Brak udziału w posiedzienu potwierdzony",
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    markable,
    markableRowType,
    allSelectable,
    headCells,
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {markable ? (
          <TableCell component="td" padding="checkbox">
            {allSelectable && !markableRowType ? (
              <Checkbox
                width="3%"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                color="primary"
                inputProps={{ "aria-label": "select all desserts" }}
              />
            ) : (
              <></>
            )}
          </TableCell>
        ) : (
          <></>
        )}
        {headCells.map((headCell) =>
          headCell.sortable ? (
            <TableCell
              width={headCell.width}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              className={!markable && headCell.main ? classes.maincell : ""}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : (
            <TableCell
              width={headCell.width}
              component={headCell.label ? "th" : "td"}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
}

const KmFilteredDocumentsTable = ({
  className,
  levelDetails,
  searchable = true,
  isAuthorized = false,
  markable = true,
  markableRowType = null,
  markVotings = false,
  votingDetails = null,
  allSelectable = true,
  oneSelectRows = false,
  headCells,
  rows,
  onSelectedRowIdsChange,
  possibleToCheckCount,
  defaultOrderBy,
  defaultOrder,
  handleConfirmButtonClick,
  onBreadcrumbsItemClick,
  disableAttendanceChecking,
  searchText,
  title,
  defaultSelected = [],
  ...rest
}) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState(
    defaultOrder ? defaultOrder : "desc"
  );
  const [orderBy, setOrderBy] = React.useState(
    defaultOrderBy ? defaultOrderBy : null
  );
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const [data, setData] = useState([]);

  useEffect(() => {
    filterData(searchText);
    setPage(0);
    setSelected(defaultSelected);
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, [rows, searchText]);

  // exclude column list from filter
  const excludeColumns = ["btns", "deleteSuccess", "id"];

  const setSelectedRowIds = (ids, idsToProceed) => {
    setSelected(ids);
    if (idsToProceed) {
      onSelectedRowIdsChange(idsToProceed);
    } else {
      onSelectedRowIdsChange(ids);
    }
  };

  const filterData = (value) => {
    if (value?.length > 0) {
      const lowercasedValue = value.toLowerCase().trim();
      if (lowercasedValue === "") setData(rows);
      else {
        const filteredData = rows.filter((item) => {
          return Object.keys(item).some((key) =>
            excludeColumns.includes(key)
              ? false
              : item[key]
              ? item[key]
                  .toString()
                  .toLowerCase()
                  .includes(lowercasedValue)
              : false
          );
        });
        setData(filteredData);
      }
    } else {
      setData(rows);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelectedRowIds(
        newSelecteds,
        data
          .filter((n) => !n.relatedCount || n.relatedCount === 0)
          .map((n) => n.id)
      );
      return;
    }
    setSelectedRowIds([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (oneSelectRows) {
      if (selectedIndex != 0) {
        newSelected.push(name);
      }
    } else {
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, name);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
    }

    setSelectedRowIds(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getValueOrDefault = (value, dataType, dataLabels) => {
    if (value) {
      if (dataType) {
        switch (dataType) {
          case 0:
            if (dataLabels && dataLabels.length === 2) {
              return value ? dataLabels[0] : dataLabels[1];
            } else {
              return value;
            }
          case 1:
            return parse(`<ul><li>${value.join("</li><li>")}</li></ul>`);
          case 2:
            return dataLabels && dataLabels[value]
              ? dataLabels[value]
              : "??nolabel??";
          default:
            return value;
        }
      }
      return value;
    }
    return kmLabels.global.empty_value_indicator;
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  return (
    <div className={classes.root}>
      {isAuthorized &&
      !disableAttendanceChecking &&
      levelDetails.attendanceCheckingActive ? (
        <Box mt={1} mb={1}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {attendanceInfo[levelDetails.committeeAttendanceDecision] ? (
                    <Typography>{`${
                      attendanceInfo[levelDetails.committeeAttendanceDecision]
                    } ${
                      levelDetails.committeeAttendanceCreatedAt
                    }`}</Typography>
                  ) : (
                    <></>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="flex-end">
                    {levelDetails.committeeAttendanceDecision ===
                      "participation" ||
                    levelDetails.committeeAttendanceDecision ===
                      "no_participation" ? (
                      <ButtonGroup
                        color="secondary"
                        variant="contained"
                        aria-label="potwierdzenie udziału w posiedzeniu KM"
                      >
                        <Button
                          onClick={(event) =>
                            handleConfirmButtonClick(event, "cancel")
                          }
                        >
                          Anuluj potwierdzenie
                        </Button>
                      </ButtonGroup>
                    ) : (
                      <ButtonGroup
                        color="secondary"
                        variant="contained"
                        aria-label="potwierdzenie udziału w posiedzeniu KM"
                      >
                        <Button
                          onClick={(event) =>
                            handleConfirmButtonClick(event, "participation")
                          }
                        >
                          Potwierdzam udział w posiedzeniu
                        </Button>
                        <Button
                          onClick={(event) =>
                            handleConfirmButtonClick(event, "no_participation")
                          }
                        >
                          Nie wezmę udziału w posiedzeniu
                        </Button>
                      </ButtonGroup>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      ) : (
        <></>
      )}
      {levelDetails.documentStructNodesBreadCrumps ? (
        <Box mt={1} mb={1}>
          <Card className={classes.breadcrumbs}>
            <CardContent className={classes.breadcrumbs}>
              <Breadcrumbs aria-label="nawigacja okrószkowa">
                {levelDetails.documentStructNodesBreadCrumps.map(
                  (breadCrumb) => {
                    return breadCrumb.id === levelDetails.id ? (
                      <Typography key={breadCrumb.id} color="textPrimary">
                        {breadCrumb.id === 1
                          ? "Katalog główny"
                          : breadCrumb.name}
                      </Typography>
                    ) : breadCrumb.id === 1 ? (
                      onBreadcrumbsItemClick ? (
                        <Link
                          color="inherit"
                          onClick={(e) =>
                            onBreadcrumbsItemClick(e, breadCrumb.id)
                          }
                        >
                          Katalog główny
                        </Link>
                      ) : (
                        <Link
                          color="inherit"
                          component={RouterLink}
                          to={`/dokumenty`}
                        >
                          Katalog główny
                        </Link>
                      )
                    ) : onBreadcrumbsItemClick ? (
                      <Link
                        color="inherit"
                        onClick={(e) =>
                          onBreadcrumbsItemClick(e, breadCrumb.id)
                        }
                      >
                        {breadCrumb.name}
                      </Link>
                    ) : (
                      <Link
                        color="inherit"
                        component={RouterLink}
                        to={`/dokumenty/${breadCrumb.id}`}
                      >
                        {breadCrumb.name}
                      </Link>
                    );
                  }
                )}
              </Breadcrumbs>
              <Divider></Divider>
              <Typography component="span" variant="subtitle1">
                Status:{" "}
              </Typography>
              <Typography component="span" variant="caption">
                {elementStatus[levelDetails.status]}
              </Typography>
              <Typography component="span" variant="subtitle1">
                {" "}
                Dostęp:{" "}
              </Typography>
              <Typography component="span" variant="caption">
                {levelDetails.publicAccess ? "publiczny" : "po zalogowaniu"}
              </Typography>
            </CardContent>
          </Card>
          {votingDetails ? (
            <Box mt={1}>
              <Alert severity="warning">
                <AlertTitle><b>Uwaga!</b></AlertTitle>
                 Głosowanie <b>{votingDetails.title}</b> dotyczy jedynie dokumentów które są
                opisane jako związane z tym głosowaniem.
              </Alert>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <></>
      )}
      <Card className={clsx(classes.root, className)} {...rest}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-label={title ? title : "Tabela"}
          >
            <EnhancedTableHead
              markable={markable}
              markableRowType={markableRowType}
              allSelectable={allSelectable}
              headCells={headCells}
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
            />
            <TableBody>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, rowindex) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `table-checkbox-${rowindex}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      {markable ? (
                        <TableCell padding="checkbox">
                          {(row.relatedCount && row.relatedCount > 0) ||
                          markableRowType === row.nodeType ? (
                            <></>
                          ) : (
                            <Checkbox
                              onClick={(event) => handleClick(event, row.id)}
                              checked={isItemSelected}
                              color="primary"
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          )}
                        </TableCell>
                      ) : (
                        <></>
                      )}

                      {headCells.map((cell, index) => {
                        if (cell.main) {
                          return (
                            <TableCell
                              key={`${index}${row.id}`}
                              id={labelId}
                              scope="row"
                              padding="none"
                              className={!markable ? classes.maincell : ""}
                            >
                              {getValueOrDefault(
                                row[cell.fieldName],
                                cell.dataType,
                                cell.dataLabels
                              )}
                            </TableCell>
                          );
                        } else {
                          return cell.kmUdField ? (
                            <TableCell
                              key={`${index}${row.id}`}
                              align={cell.dataAlign}
                            >
                              <UserAndDate
                                username={getValueOrDefault(
                                  row[cell.fieldName],
                                  cell.dataType,
                                  cell.dataLabels
                                )}
                                date={getValueOrDefault(
                                  row[cell.fieldName2],
                                  cell.dataType,
                                  cell.dataLabels
                                )}
                                separator=", "
                              />
                            </TableCell>
                          ) : (
                            <TableCell
                              key={`${index}${row.id}`}
                              align={cell.dataAlign}
                              id={cell.aria ? labelId : ""}
                            >
                              {cell.component
                                ? cell.component(
                                    row,
                                    cell.customHandlers,
                                    markVotings
                                  )
                                : cell.lp
                                ? rowindex + 1
                                : getValueOrDefault(
                                    row[cell.fieldName],
                                    cell.dataType,
                                    cell.dataLabels
                                  )}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  );
                })}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={headCells.length + 1} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage="Wierszy:"
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          title="aaa"
        />
      </Card>
    </div>
  );
};

export default KmFilteredDocumentsTable;
